module.exports = __webpack_public_path__ + "img/linux.9b98e3b1.svg";